export const genderOptions = [
  { id: "آقا", title: "آقا" },
  { id: "خانم", title: "خانم" },
];
export const gender = { male: "آقا", female: "خانم" };





